// Example: src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Optional: Create and import a CSS file for styling

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Clean Sweeps LLC. All rights reserved.</p>
      <div className="footer-links">
        <Link to="/resources">Resources</Link>
        <Link to="/tos">Terms of Service</Link>
        <Link to="/setup">Setup Guides</Link>
        <Link to="/policy">Privacy Policy</Link>
      </div>
    </footer>
  );
};

export default Footer;
